import styled from "styled-components"
import { DashboardLayout } from "../../components/layouts"
import { COLORS, SCREEN_SIZES } from "../../constants"
import { Row, Col } from "reactstrap"
import { Refer } from "../../components"
import { CustomButton, SelectGamesModal, SelectTrialGamesModal } from "../../components"
import { Switch, Route, Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react"
import MyLevelsScreen from "../parentDashboard/MyLevelsScreen"
import ChildResults from "../ChildResults"
import ChildGamesSecondary from "../ChildGamesSecondary"
import { useSelector } from "react-redux"
import ParentChildScreen from "../parentDashboard/ParentChildScreen"
import refer from "../../assets/images/refer.svg"
import Levels from "./Levels"
import Games from "./Games"
import Teacher from "../../assets/avatars/Teacher.svg"

const StyledDashboardMenu = styled.ul`
    border-bottom: 6px solid ${COLORS.light_blue};
    height: 36px;
`;
const StyledLink = styled(NavLink)`
    display: block;
    color: ${props => props.tabactive ? ` ${COLORS.text_dark_blue}` : `${COLORS.light_blue}`};
    border-bottom: ${props => props.tabactive ? `6px solid ${COLORS.text_dark_blue}` : ""};
    transition: color 0.2s ease-in;
    padding-bottom: 5px;
    margin-right: 10px;
    font-size: 17px;
    &:hover{
        color: ${props => props.tabactive ? ` ${COLORS.text_dark_blue}` : `${COLORS.light_blue}`};
        text-decoration: none;
        border-bottom: 6px solid ${COLORS.text_dark_blue};
    }
`;
function ParentDashboard(props) {
    const location = useLocation();
    const user = useSelector(state => state.auth.user.user)
    const [toggleActive, setToggleActive] = useState(true);
    const [modalVisible, setModalVisible] = useState(false);
    const [trialGameModalVisible, setTrialsGameModalVisible] = useState(false);
    const [referVisible, setReferVisible] = useState(false);

    const onCloseClick = () => {
        setModalVisible(false);
    }
    useEffect(() => {
        console.log(location.pathname.split("/")[2]);
    }, [])
    return (
        <>
            <DashboardLayout parent>
                <Row className="">
                    <Col lg={4} className="mt-2">
                        <div className="styled-card pt-5 pb-4 px-4">
                            <div className="d-flex flex-column align-items-center">
                                <img src={Teacher} width={100} />
                                <h5 className="mt-2" style={{ color: COLORS.text_dark_blue }}>{user.name}</h5>
                            </div>
                            <CustomButton
                                className="w-100 mt-3 flex-grow-1"
                                bgColor="#FFE500"
                                hover="#DDC600"
                                color="#958600"
                                onClick={() => setTrialsGameModalVisible(true)}
                            >
                                Trial Games
                            </CustomButton>
                            <CustomButton
                                className="w-100 mt-3 flex-grow-1"
                                bgColor={COLORS.orange}
                                hover={COLORS.orange_hover}
                                color={COLORS.dark_orange}
                                onClick={() => setModalVisible(true)}
                            >
                                My Games
                            </CustomButton>
                            <Link to="/store">
                                <CustomButton className="w-100 mt-3 flex-grow-1" bgColor={COLORS.green} hover={COLORS.text_green} color={COLORS.text_dark_green}>Buy More Games</CustomButton>
                            </Link>


                        </div>
                        <div className="styled-card py-3 px-3 mt-3 d-none d-lg-block" style={{ backgroundColor: "white" }} style={{ cursor: "pointer" }} onClick={() => setReferVisible(true)}>
                            <div className="d-flex justify-content-center flex-wrap align-items-center">
                                <img src={refer} width={30} className="mr-1" />
                                <div className="d-inline-block text-center ml-2">Refer a friend!</div>
                            </div>
                        </div>

                    </Col>
                    <Col lg={8} className="mtop-sm-3">
                        <StyledDashboardMenu className="d-flex list-unstyled">
                            <li>
                                <StyledLink tabactive={location.pathname == '/dashboard' || location.pathname.split("/")[2] == "games"} onClick={() => setToggleActive(true)} to="/dashboard">Worksheets</StyledLink>
                            </li>
                            {/* <li>
                                <StyledLink tabactive={location.pathname == '/dashboard/levels' || location.pathname.split("/")[2] == "games"} onClick={() => setToggleActive(false)} to="/dashboard/levels">My Levels</StyledLink>
                            </li> */}
                        </StyledDashboardMenu>

                        {/* Parent Dashboard Tabs */}

                        <Switch>
                            {/* <Route exact path="/dashboard/ref/:ref" component={ParentChildScreen} />
                            <Route path="/dashboard" exact component={ParentChildScreen} /> */}
                            <Route path="/dashboard/games/:levelno" exact component={Games} />
                            <Route exact path="/dashboard" component={Levels} />
                            {/* <Route exact path="/dashboard/child/:id/games/:levelno" component={ChildGamesSecondary} />
                            <Route exact path="/dashboard/child/:id" component={ChildResults} /> */}

                        </Switch>

                    </Col>
                </Row>
            </DashboardLayout>
            <Refer visible={referVisible} onClose={() => setReferVisible(false)} />
            <SelectTrialGamesModal modalVisible={trialGameModalVisible} onClose={() => setTrialsGameModalVisible(false)} containerheight="80%" />
            {/* <SelectGamesModal modalVisible={trialGameModalVisible} onClose={() => setTrialsGameModalVisible(false)} containerheight="80%" mode={1} /> */}
            <SelectGamesModal modalVisible={modalVisible} onClose={onCloseClick} containerheight="80%" mode={2} isTellFunctionality={false} />
        </>
    );
}

export default ParentDashboard;